import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { SkillEntityConfig } from "./config";
import { SkillFilters } from "./filters";
import { SkillMethods } from "./methods";

@HyperEntity("skill", SkillEntityConfig)
export class Skill extends extender(SkillFilters, SkillMethods) {
  @Fields.uuid({ allowApiUpdate: false })
  id = "";

  @Fields.string({ caption: "יכולות" })
  name = "";

  @Fields.string()
  description = "";

  @Fields.string({
    dbName: "image_id",
  })
  imageId = "";

  @Fields.number()
  order = 0;

  @Fields.string()
  type = "";

  @Fields.string()
  category = "";

  @Fields.string({
    dbName: "parent_skill_id",
  })
  parentSkillId = "";

  @Relations.toOne(() => Skill, { field: "parentSkillId" })
  parentSkill?: Skill;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
